import 'react-tabs/style/react-tabs.css'
import 'remixicon/fonts/remixicon.css'
import 'react-medium-image-zoom/dist/styles.css'
import './src/styles/main.scss'
import "@fontsource/vollkorn/400-italic.css"

import App from "./App"
export const wrapRootElement = App
